<template>
  <v-container class="container">
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <!--      <loading :active.sync="isLoading" :is-full-page="true"></loading>-->
    <div>
      <v-row style="min-height: 68px">
        <v-col class="pb-5">
          <v-skeleton-loader v-if="!form" height="52px" type="heading"></v-skeleton-loader>
          <div v-else v-html="form[`name_${lang}`]" class="header bold text-tcdc-green"></div>
        </v-col>
      </v-row>
      <v-layout justify-space-between>
        <v-flex>
          <div class="d-flex flex-1 align-center">
            <div class="pr-3 d-flex align-center">
              <img src="../../assets/icons/sorts/calendar.png" class="eventdetail-card-logo mr-4" />
              <span v-if="form && form['events_date']" class="bold text-uppercase text-tcdc-green"> {{ lang === 'th' ? form['events_date_th'] :
                form['events_date'] }}</span>
              <span v-else-if="form" class="bold text-uppercase text-tcdc-green">{{ form[`start_date_${lang}`] | moment('DD MMM YYYY') }} -
                {{ form[`end_date_${lang}`] | moment('DD MMM YYYY') }}</span>
            </div>
            <div class="d-flex align-center">
              <img src="../../assets/icons/marker.png" class="eventdetail-card-logo mr-4" />
              <span class="bold text-uppercase text-tcdc-green">{{ form ? form[`location_name_${lang}`] : '' }}</span>
            </div>
          </div>
        </v-flex>
        <v-flex shrink>
          <ShareButton v-if="form" mode="program" :title="form[`name_${lang}`]"></ShareButton>
        </v-flex>
      </v-layout>
      <v-row>
        <v-col>
          <div v-if="!form">
            <v-responsive :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 2.8 : 1">
              <v-skeleton-loader
                  type="image"
                  height="100%"
                  width="100%"
                  boilerplate
              ></v-skeleton-loader>
            </v-responsive>
          </div>

          <div v-else>
            <!-- desktop -->
            <v-img eager class="hidden-sm-and-down" :src="form.img_cover_desktop" aspect-ratio="2.8">
              <template v-slot:placeholder>
                <v-sheet color="#EFEFEF" class="fill-height"></v-sheet>
              </template>
            </v-img>
            <!-- mobile -->
            <v-img eager class="hidden-md-and-up" :src="form.img_cover_mobile" aspect-ratio="1">
              <template v-slot:placeholder>
                <v-sheet color="#EFEFEF" class="fill-height"></v-sheet>
              </template>
            </v-img>
          </div>
        </v-col>
      </v-row>
      <v-col align="center" style="padding: 20px">
        <!--        <div id='zipevent-widget-container'></div>-->
        <span v-if="this.widget_status != true && this.widget_status != null && this.form?.active_button == 1">
          <!--                  <GreenButton :label="$t('event.more')" :height="height"-->
          <!--                               @click.native="goToRegister(form.url)"-->
          <!--                               v-if="form && form.url && form.active_button == 1"/>-->
          <GreenButton :label="form[`button_name_${lang}`] ? form[`button_name_${lang}`] : $t('event.register')"
            :height="height" @click.native="goToRegister(form.url)" v-if="form && form.url && form?.active_button == 1" />
        </span>
      </v-col>
      <v-row class="pb-8">
        <v-col>
          <div id="content"></div>
          <div id="skeleton-content">
              <v-skeleton-loader
                  type="paragraph"
              ></v-skeleton-loader>
          </div>
          <!-- <div id="content" style="white-space: pre-line;"></div> -->
          <!-- <span class="vhtml" v-html="form ? form[`detail_${lang}`] : ''">
          </span> -->
        </v-col>
      </v-row>
      <span v-if="this.widget_status != true && this.widget_status != null && this.form?.active_button == 1">
        <v-col align="center">
          <GreenButton :label="form[`button_name_${lang}`] ? form[`button_name_${lang}`] : $t('event.register')"
            :height="height" @click.native="goToRegister(form.url)" v-if="form && form.url && form?.active_button == 1" />
        </v-col>
      </span>
      <div v-if="relatedItem.length > 0">
        <v-row class="pt-8">
          <v-col>
            <span class="text-tcdc-green header bold text-uppercase">{{ $t('event.related') }}</span>
          </v-col>
        </v-row>
        <v-row class="d-flex flex-wrap" v-if="relatedItem.length > 0">
          <template v-for="(item, index) of relatedItem">
            <v-col cols="12" md="6" :key="index">
              <EventCard class="cursor-pointer" :name="item[`name_${lang}`]" :time_start="item.start_date"
                :time_end="item.end_date" :place="item.location_name"
                :img="$vuetify.breakpoint.smAndDown ? item.img_cover_mobile : item.img_cover_desktop"
                :href-link="eventDetailHandler(item.product_id)" />
            </v-col>
          </template>
        </v-row>
        <v-row v-else class="grey--text mt-3 px-2">
          <v-col>
            {{ $t('event.no-related') }}
          </v-col>
        </v-row>
      </div>
    </div>
    <span v-if="this.widget_status == true && this.widget_status != null">
      <div id="zipevent-widget-container"></div>
    </span>
  </v-container>
</template>

<script>
import EventCard from "../../components/cards/EventCard";
import { mapState } from "vuex";
import GreenButton from "../../components/buttons/GreenButton";
import ShareButton from "../../components/buttons/ShareButton";
// import Loading from 'vue-loading-overlay';
import { setMetaTags } from '@/util/Constants'
import { BreadcrumbUtil } from "@/util/BreadcrumbUtil";

export default {
  components: {
    GreenButton,
    EventCard,
    ShareButton,
    // Loading
  },
  computed: {
    ...mapState({
      // form: state => {
      //   let src = state.Program.form.img_cover_desktop
      //   let srcM = state.Program.form.img_cover_mobile
      //   let fullPath = ''
      //   let fullPathM = ''
      //   if (src && src.includes('https://cdn.zipeventapp.com/')) {
      //     fullPath = src.split('/')
      //     let xl = 'xl-' + fullPath.at(-1)
      //     fullPath.pop()
      //     fullPath.push(xl)
      //     fullPath = fullPath.join('/')
      //   }
      //   if (srcM && srcM.includes('https://cdn.zipeventapp.com/')) {
      //     fullPathM = srcM.split('/')
      //     let xl = 'xl-' + fullPathM.at(-1)
      //     fullPathM.pop()
      //     fullPathM.push(xl)
      //     fullPathM = fullPathM.join('/')
      //   }
      //   return {
      //     ...state.Program.form,
      //     img_cover_desktop: fullPath ? fullPath : state.Program.form.img_cover_desktop,
      //     img_cover_mobile: fullPathM ? fullPathM : state.Program.form.img_cover_mobile
      //   }
      // },
      branchId: state => {
        return state.Branch.branch_id;
      },
      branchName: state => {
        return state.Branch.branch_name;
      },
      allBranches: state => {
        return state.Branch.branches;
      },
      lang: state => {
        return state.Branch.lang;
      },
      event_id: state => {
        return state.Program.event_id;
      },
      widget_status: state => {
        return state.Program.widget_status;
      },
    }),
    branchChanged: function () {
      return this.branchName;
    },
    routeId: function () {
      return this.$route.params.id;
    }
  },
  watch: {
    branchChanged: function () {
      this.items[0].text = this.branchChanged;
      let path;
      for (const b of this.allBranches) {
        if (this.branchId === b.branch_id) {
          if (this.branchId === 0) {
            path = `/home`;
            break;
          }
          path = `/home/${b.tag_name}`;
          break;
        }
      }
      this.items[0].to = path;
      this.items[1].to = path;
    },
    routeId: async function () {
      this.isLoading = true;
      await this.$store.dispatch("Program/getProgramEventById", {
        id: this.$route.params.id,
        lang: this.lang,
      })

    },
    lang() {
      if (this.form) {
        const contentFromDatabase = this.form[`detail_${this.lang}`];
        // console.log('banana', contentFromDatabase);
        // Replace line breaks '\n' with '<br>' to display them correctly in HTML.
        const formattedContent = contentFromDatabase;

        // Display the formatted content in the container element.
        document.getElementById('content').innerHTML = formattedContent;

      }
    }
  },
  async mounted() {
    // this.setItemBranch();
    this.isLoading = true;
    this.items = BreadcrumbUtil.setServiceItem(
      this.items,
      this.branchId,
      this.branchName,
      this.allBranches,
      this.lang
    )
    let res = await this.$store.dispatch("Program/getProgramEventById", {
      id: this.$route.params.id,
      lang: this.lang,
    });
    let src = res.img_cover_desktop
    let srcM = res.img_cover_mobile
    let fullPath = ''
    let fullPathM = ''
    if (src && src.includes('https://cdn.zipeventapp.com/')) {
      fullPath = src.split('/')
      let xl = 'xl-' + fullPath.at(-1)
      fullPath.pop()
      fullPath.push(xl)
      fullPath = fullPath.join('/')
    }
    if (srcM && srcM.includes('https://cdn.zipeventapp.com/')) {
      fullPathM = srcM.split('/')
      let xl = 'xl-' + fullPathM.at(-1)
      fullPathM.pop()
      fullPathM.push(xl)
      fullPathM = fullPathM.join('/')
    }
    this.form = res;
    this.form.img_cover_desktop = fullPath ? fullPath : this.form.img_cover_desktop;
    this.form.img_cover_mobile = fullPathM ? fullPathM : this.form.img_cover_mobile;
    setTimeout(() => {
      const contentFromDatabase = this.form[`detail_${this.lang}`];
      // Replace line breaks '\n' with '<br>' to display them correctly in HTML.
      const formattedContent = contentFromDatabase;
      // console.log("data", contentFromDatabase);
      // const formattedContent = contentFromDatabase.replace(/\n/g, '<br>');
      // Display the formatted content in the container element.
      let contentElement = document.getElementById('content');
      let sk = document.getElementById('skeleton-content');
      contentElement.innerHTML = formattedContent
      sk.remove()
    }, 500)

    setMetaTags(document, window, this.form[`name_${this.lang}`], this.form[`name_${this.lang}`], this.form.img_cover_desktop)
    this.$store.dispatch("Program/onGetWebWidget", this.event_id).then(() => {
      this.checkWebWidget();
    });
    this.$store.dispatch("Program/onGetRelatedEventById", this.$route.params.id).then(res => {
      this.relatedItem = res
    });
    this.isLoading = false;

  },
  // mounted() {
  //   if (this.form) {


  //     const contentFromDatabase = this.form[`detail_${this.lang}`];
  //     // Replace line breaks '\n' with '<br>' to display them correctly in HTML.
  //     const formattedContent = contentFromDatabase.replace(/\n/g, '<br>');

  //     // Display the formatted content in the container element.
  //     document.getElementById('content').innerHTML = formattedContent;

  //   },
  beforeDestroy() {
    this.$store.commit('Program/clearForm')
  },
  methods: {
    checkWebWidget() {
      if (this.widget_status == true) {
        let widgetID = this.form.event_id;
        this.addWidget(widgetID);
      }
    },
    addWidget(widgetID) {

      let param = {
        eventId: widgetID,
        containerId: 'zipevent-widget-container',
        containerHeight: '500',
        containerWidth: '450',
        language: this.lang
      };

      let w = window;
      // let d = document;
      // let c = d.createElement('script');
      // c.async = 1;
      // c.src = 'https://widget.zipeventapp.com/js/widget.js';
      w.ZipeventWidget.createWidget(param)
      // let e = document.currentScript;
      // e.parentNode.appendChild(c);
      // let f = function () {
      //
      // };
      // c.attachEvent ? c.attachEvent('onload', f) : c.addEventListener('load', f, false);
      // w.attachEvent ? w.attachEvent('onload', l) : w.addEventListener('load', l, false);

    },
    eventDetailHandler(id) {
      // console.log('related', id)
      return `/${this.lang}` + `/events/${id}`
    },
    setItemBranch() {
      if (this.branchName) {
        this.items[0].text = this.branchName;
        let path;
        for (const b of this.allBranches) {
          if (this.branchId === b.branch_id) {
            if (this.branchId === 0) {
              path = `/home`;
              break;
            }
            path = `/home/${b.tag_name}`;
            break;
          }
        }
        this.items[0].to = path;
        this.items[1].to = path;
      }
    },
    goToRegister(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
  },
  data: () => ({
    form: null,
    height: '35px',
    width: '150px',
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: true,
        to: "/home/tcdc-bangkok"
      },
      {
        text: "PROGRAM",
        disabled: false,
        to: "/home"
      }
    ],
    relatedItem: []
  })
};
</script>

<style scoped>
.eventdetail-card-logo {
  height: 25px;
  object-fit: contain;
}
</style>
